import { API_CONFIG, joinCdnUrl } from "./config";

const responseCache = new Map();
const inFlightRequests = new Map();

const fetchJson = async (url, { signal } = {}) => {
  if (responseCache.has(url)) {
    return responseCache.get(url);
  }

  if (!inFlightRequests.has(url)) {
    const request = fetch(url, { signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with ${response.status}`);
        }
        return response.json();
      })
      .then((payload) => {
        responseCache.set(url, payload);
        return payload;
      })
      .finally(() => {
        inFlightRequests.delete(url);
      });

    inFlightRequests.set(url, request);
  }

  return inFlightRequests.get(url);
};

const mapApiEvent = (event) => ({
  id: event.eventId,
  slug: String(event.eventId),
  title: event.head || event.name || "Sode Matha Event",
  subtitle: event.englishText || event.kannadaText || event.name || "",
  description: event.englishText || event.kannadaText || event.name || "",
  date: event.eventDate ? new Date(event.eventDate).toISOString() : "",
  thumbnail: joinCdnUrl(API_CONFIG.eventsCdnUrl, event.eventThumbnail),
});

const mapEventImages = (images = {}) =>
  Object.keys(images || {}).map((imagePath) => joinCdnUrl(API_CONFIG.eventsCdnUrl, imagePath));

const mapApiEventDetail = (event = {}, metadata = {}) => ({
  id: event.eventId || metadata.id,
  slug: String(event.eventId || metadata.slug || ""),
  title: event.head || event.name || metadata.title || "Sode Matha Event",
  subtitle: metadata.subtitle || "",
  description: event.englishText || event.kannadaText || metadata.description || "",
  date: metadata.date || "",
  thumbnail: metadata.thumbnail || "",
  images: mapEventImages(event.images),
});

export const fetchEventsPage = async ({ size = 15, index = 0, signal } = {}) => {
  if (!API_CONFIG.eventsEndpoint || !API_CONFIG.eventsInstitutionReference) {
    throw new Error("Recent events API configuration is missing.");
  }

  const params = new URLSearchParams({
    institutionReference: API_CONFIG.eventsInstitutionReference,
    status: "1",
    eventTypeId: "1",
    size: String(size),
    index: String(index),
  });

  const payload = await fetchJson(`${API_CONFIG.eventsEndpoint}?${params.toString()}`, { signal });
  return {
    events: (payload?.data?.results || []).map(mapApiEvent),
    page: payload?.data?.page || { index, size, total: 0 },
  };
};

export const fetchRecentEvents = async ({ size = 15, index = 0, signal } = {}) => {
  const { events } = await fetchEventsPage({ size, index, signal });
  return events;
};

export const fetchEventById = async (eventId, { signal, metadata } = {}) => {
  if (!API_CONFIG.eventsEndpoint) {
    throw new Error("Event detail API configuration is missing.");
  }

  const payload = await fetchJson(`${API_CONFIG.eventsEndpoint}/${eventId}`, { signal });
  return mapApiEventDetail(payload?.data, metadata);
};
